module.exports = __webpack_public_path__ + "assets/78e7593a21d2c8b5e871a6ccb48de1e9.png";